define(["require", "exports", "jquery", "../analytics", "../history", "../controls/paging-info"], function (require, exports, $, analytics_1, history_1, paging_info_1) {
    "use strict";
    exports.__esModule = true;
    var defaults = {
        className: 'photoshow',
        sel: 'img, canvas',
        width: 320,
        screenWidth: 480,
        speed: 1,
        current: 0,
        gutter: 0,
        onCurrentChange: null
    };
    function getCurIndex($sel) {
        var $paging = $sel.find('.paging');
        return parseInt($paging.data('cur') || '0');
    }
    function isZoomed() {
        return document.documentElement.clientWidth / window.innerWidth > 1;
    }
    var thumbImage = 'thumb-image';
    var fullImage = 'full-image';
    function setCurrentPhoto($show, curIndex) {
        var viewport = $show.find('.photo-viewport');
        var options = $show.data('touch-slider-options');
        var curWidth = $show.hasClass('full-screen') ? options.screenWidth : options.width;
        var left = -curIndex * (curWidth + options.gutter);
        var prevLeft = viewport.position().left;
        var t = Math.abs(prevLeft - left) / options.speed;
        if (t > 0) {
            $show.find('.photo-viewport').animate({ 'left': left + 'px' }, t);
        }
        var $paging = $show.find('.paging');
        viewport.find('>div').toggleClass('current', false);
        $(viewport.find('>div')[curIndex]).addClass('current');
        $paging.data('cur', curIndex);
        paging_info_1.renderPaging($paging);
        if (options.onCurrentChange) {
            options.onCurrentChange(curIndex);
        }
    }
    function changeItemCount($paging, delta) {
        if (delta === void 0) { delta = 1; }
        var prevTotal = parseInt($paging.data('total'));
        var total = Math.max(0, (isNaN(prevTotal) ? 1 : prevTotal + delta));
        var prevCur = Math.min(parseInt($paging.data('cur')), total - 1);
        var cur = isNaN(prevCur) ? 0 : prevCur;
        $paging.data('total', total).data('cur', cur);
        paging_info_1.renderPaging($paging);
    }
    function asTouches(evt) {
        var origEvt = evt.originalEvent;
        if (evt.type == 'touchend' || evt.type == 'touchcancel')
            return origEvt.changedTouches;
        return origEvt.touches || [origEvt];
    }
    function toggleImageSize($img, attrFrom, attrTo) {
        $img.data(attrTo, $img.attr('src')).attr('src', $img.data(attrFrom));
    }
    function isFullScreen() {
        return $('body').hasClass('full-screen-photo');
    }
    function exitFullScreen($show) {
        var result = $.Deferred();
        if (isFullScreen()) {
            result.resolve(!toggleFullScreenMode($show));
        }
        else {
            result.resolve(false);
        }
        return result.promise();
    }
    var parentFor = function ($sel) { return $sel.data('parent') || $sel.parent(); };
    function toggleFullScreenMode($show) {
        var isFullScreen = !$show.hasClass('full-screen');
        if (isFullScreen) {
            $show.prependTo('body');
        }
        else {
            var place = $('.product-details-info .picture .overview  + .picture');
            if (!place.length) {
                place = $('.product-details-info .picture');
            }
            if (place.length) {
                $show.prependTo($(place[0]));
            }
        }
        $('body').toggleClass('full-screen-photo', isFullScreen);
        analytics_1["default"]('slide', isFullScreen ? 'enterFullScreen' : 'leaveFullScreen');
        $show.toggleClass('full-screen', isFullScreen);
        var curIndex = getCurIndex($show);
        $show.find('img').each(function (i, img) {
            var attrFrom = isFullScreen ? fullImage : thumbImage;
            var attrTo = isFullScreen ? thumbImage : fullImage;
            toggleImageSize($(img), attrFrom, attrTo);
        });
        if (isFullScreen) {
            $('<div class="exit-full-screen">back</div>').appendTo($show);
        }
        else {
            $show.find('.exit-full-screen').remove();
        }
        setCurrentPhoto($show, curIndex);
        $(window).scrollTop(0);
        return isFullScreen;
    }
    function shouldHandleSlide($show, touches) {
        var options = $show.data('touch-slider-options');
        if (options && options.frozen || touches.length > 1 || (isZoomed() && $show.hasClass('full-screen'))) {
            return false;
        }
        return true;
    }
    function init($sel, settings) {
        var options = $.extend({}, defaults, settings);
        $sel.addClass('photo-viewport');
        var prerendered = parentFor($sel).hasClass(options.className);
        if (!prerendered) {
            $sel.wrap("<div class=\"" + options.className + "\"/>");
        }
        $sel.each(function (i, list) {
            var $list = $(list);
            var show = $list.parent();
            var $slides = $list.find(options.sel);
            var $paging = $("<div class=\"paging\"></div>");
            show.data('touch-slider-options', options);
            $slides.each(function (i, img) {
                var $img = $(img);
                if (!prerendered) {
                    $img.wrap('<div></div>');
                    if ($img.data('slide_title')) {
                        $('<label class="title"></label>').text($img.data('slide_title')).insertAfter($img);
                    }
                }
            });
            if (!show.find('.paging').length) {
                $paging.appendTo(show);
            }
            else {
                $paging = show.find('.paging');
            }
            $paging.data('cur', options.current)
                .data('total', $slides.length)
                .data('parent', show)
                .text(options.current + 1 + " of " + $slides.length);
            show.on('touchstart MSPointerDown', function (e) {
                var touches = asTouches(e);
                if (!shouldHandleSlide(show, touches)) {
                    return;
                }
                var touch = touches[0];
                show.data('touchStart', { x: touch.clientX, y: touch.clientY });
            });
            show.on('touchmove MSPointerMove', function (e) {
                var touches = asTouches(e);
                if (!shouldHandleSlide(show, touches)) {
                    return;
                }
                var touch = touches[0];
                var start = show.data('touchPrev') || show.data('touchStart');
                var cur = { x: touch.clientX, y: touch.clientY };
                if (start) {
                    var dy = cur.y - start.y;
                    var dx = cur.x - start.x;
                    if (Math.abs(dy) > Math.abs(dx)) {
                        return;
                    }
                    if (Math.abs(dx) > 5) {
                        show.find('.photo-viewport').css('left', '+=' + dx + 'px');
                        show.data('touchPrev', cur);
                    }
                    e.preventDefault();
                }
            });
            show.on('touchend touchcancel MSPointerUp MSPointerCancel', function (e) {
                var touches = asTouches(e);
                if (!shouldHandleSlide(show, touches)) {
                    return;
                }
                var touch = touches[0];
                var start = show.data('touchStart');
                var cur = { x: touch.clientX, y: touch.clientY };
                if (start) {
                    var dx = Math.abs(cur.x - start.x);
                    var dy = Math.abs(cur.y - start.y);
                    var curIndex = getCurIndex(parentFor($paging));
                    if (dx > 30 && dy / dx < 0.75) {
                        if (cur.x > start.x) {
                            curIndex = Math.max(0, curIndex - 1);
                        }
                        else {
                            curIndex = Math.min(curIndex + 1, parseInt($paging.data('total')) - 1);
                        }
                    }
                    setCurrentPhoto(show, curIndex);
                    analytics_1["default"]('slide', 'photo', show.hasClass('full-screen') ? 'fullScreen' : null);
                }
                show.removeData('touchStart').removeData('touchPrev');
            });
            if (!options.disableFullScreen) {
                show.on('click', 'img,canvas', function (e) {
                    if (show.hasClass('full-screen')) {
                        return;
                    }
                    var enterFullScreen = toggleFullScreenMode(show);
                    history_1["default"].push('photoShow', function () {
                        show.touchSlider('exit');
                    });
                });
                show.on('click', '.exit-full-screen', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    history_1["default"].pop();
                });
            }
        });
        return $sel;
    }
    function current($sel, index) {
        if ($.isNumeric(index)) {
            setCurrentPhoto(parentFor($sel), index);
            return index;
        }
        else {
            return getCurIndex($sel);
        }
    }
    function freeze($sel, freeze) {
        var options = parentFor($sel).data('touch-slider-options');
        if (options) {
            options.frozen = freeze;
            parentFor($sel).find('.paging').toggleClass('hidden', freeze);
        }
    }
    (function ($) {
        $.fn.touchSlider = function (methodOrOptions, options) {
            if (methodOrOptions === "init") {
                return init(this, options);
            }
            else if (methodOrOptions === "current") {
                return current(this, options);
            }
            else if (methodOrOptions === "exit") {
                toggleFullScreenMode(this);
                return this;
            }
            else if (methodOrOptions === 'freeze') {
                freeze(this, options);
                return this;
            }
            else if (methodOrOptions === 'exitFullScreen') {
                return exitFullScreen(this);
            }
            else if (methodOrOptions === 'dec') {
                changeItemCount(this, -1);
                return this;
            }
            else if (methodOrOptions === 'inc') {
                changeItemCount(this, 1);
                return this;
            }
            else if ($.isPlainObject(methodOrOptions)) {
                return init(this, methodOrOptions);
            }
            else {
                $.error("Method " + methodOrOptions + " doesn't exist in touchSlider");
            }
        };
    })($);
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/touch-slider.js
// module id = 1
// module chunks = 0